import classNames from "classnames";
import { toast } from "react-toastify";
import React, { useState } from "react";
import { SurveyEntity } from "./../../../application/domain/surveys/survey-entity";
import { BaseModal } from "../../molecules/modal/base-modal";

export const CopySurveyModal: React.FC<{
  onCopy: (newName: string) => Promise<void>;
  survey: SurveyEntity;
  onClose: () => void;
  isActive: boolean;
}> = ({ onCopy, survey, onClose, isActive }) => {
  const newSurveyNameSuffix = " コピー";
  const defaultSurveyName = `${survey.name}${newSurveyNameSuffix}`;
  const [newName, setNewName] = useState<string>(defaultSurveyName);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const closeModal = () => {
    setNewName("");
    onClose();
  };
  const copySurvey = async () => {
    setIsSubmitting(true);
    try {
      await onCopy(newName);
      toast.success("アンケートのコピーを作成しました。");
      setIsSubmitting(false);
      closeModal();
    } catch (e) {
      toast.error("アンケートのコピーに失敗しました。");
      setIsSubmitting(false);
    }
  };

  return (
    <BaseModal
      title={"アンケートのコピー"}
      isActive={isActive}
      onClose={closeModal}
    >
      <section className="modal-card-body">
        <div className="field">
          <div className="is-small">
            「{survey.name}」をコピーして新規手続きを作成します。
          </div>
        </div>
        <div className="field">
          <div className="label">アンケート名称</div>
          <input
            type="text"
            className={classNames("input")}
            value={newName}
            onChange={(e) => {
              setNewName(e.target.value);
            }}
          />
        </div>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={closeModal}>
          キャンセル
        </button>
        <button
          className={classNames("button is-info is-fullwidth", {
            "is-loading": isSubmitting,
          })}
          onClick={copySurvey}
          disabled={!newName}
        >
          {"作成する"}
        </button>
      </footer>
    </BaseModal>
  );
};
